import { VatReturnLog } from 'store/vat/models';

const toTime = (value: string | null | undefined): number => {
  if (!value) return 0;
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? 0 : time;
};

const activityTime = (log: VatReturnLog): number =>
  toTime(log.lastUpdatedDate || log.generatedDate || log.submissionDate);

/** Default submissions table order: newest activity first, then latest period. */
export const compareVatReturnLogs = (
  a: VatReturnLog,
  b: VatReturnLog
): number => {
  const activityDiff = activityTime(b) - activityTime(a);
  if (activityDiff !== 0) return activityDiff;

  const periodDiff =
    toTime(b.fromReportingDate) - toTime(a.fromReportingDate);
  if (periodDiff !== 0) return periodDiff;

  return String(b.uuid || '').localeCompare(String(a.uuid || ''));
};

export const sortVatReturnLogs = (logs: VatReturnLog[]): VatReturnLog[] =>
  [...logs].sort(compareVatReturnLogs);
